export default {
      id: "icon-sample-usage",
      viewBox: "0 0 0 0",
      url: __webpack_public_path__ + "Assets/Sprite.svg#icon-sample",
      toString: function () {
        return this.url;
      }
    }